import store from '@/app/store';
import Vue from 'vue';
import Router from 'vue-router';
import Home from '../components/Home';
import WrhDashboard from '../../modules/wrh-dashboard/app';
import WreDashboard from '../../modules/wre-dashboard/app';
import WrDashboard from '../../modules/wr-dashboard/app';
import WrNotaryCertificate from '../../modules/wr-notary-certificate/app';
import SharedLink from '../../modules/shared-link/app';
import Login from '../components/Login';
import RoAdminLoginError from '../components/RoAdminLoginError';
import AccessDeniedError from '../components/AccessDeniedError';
import ServerError from '../components/ServerError';

const isMspWr = process.env.VUE_APP_MSP_MODE === 'true';

Vue.use(Router);

const routes =
  isMspWr ?
    [
      {
        path: '/',
        name: 'wrHome',
        component: Home
      },
      {
        path: '/enterprise/login',
        name: 'wrLogin',
        component: Login
      },
      {
        path: '/error/ro-admin',
        name: 'ro-admin-login-error',
        component: RoAdminLoginError
      },
      {
        path: '/error/access-denied',
        name: 'access-denied-error',
        component: AccessDeniedError
      },
      {
        path: '/error/server-error',
        name: 'server-error',
        component: ServerError
      },
      {
        path: '/enterprise/dashboard',
        component: WrDashboard.component,
        children: [...WrDashboard.routes]
      },
      {
        path: '/links/:cipher',
        component: SharedLink.component,
        children: [...SharedLink.routes]
      },
      {
        path: '/enterprise/certificate/:id',
        component: WrNotaryCertificate.component,
        children: [...WrNotaryCertificate.routes]
      }
    ] : [
      {
        path: '/',
        name: 'home',
        component: Home
      },
      {
        path: '/login',
        name: 'wrhLogin',
        component: Login
      },
      {
        path: '/enterprise/login',
        name: 'wreLogin',
        component: Login
      },
      {
        path: '/dashboard',
        component: WrhDashboard.component,
        children: [...WrhDashboard.routes]
      },
      {
        path: '/enterprise/dashboard',
        component: WreDashboard.component,
        children: [...WreDashboard.routes]
      },
      {
        path: '/links/:cipher',
        component: SharedLink.component,
        children: [...SharedLink.routes]
      },
      {
        path: '/error/access-denied',
        name: 'access-denied-error',
        component: AccessDeniedError
      },
      {
        path: '/error/server-error',
        name: 'server-error',
        component: ServerError
      },
    ];

const router = new Router({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.path.startsWith('/error/')) {
    return next();
  }
  if (to.path.startsWith('/links/')) {
    return next();
  }

  if (isMspWr) {
    if (to.path.startsWith('/enterprise/certificate/')) {
      return next();
    }

    if (store.getters.isAuthenticated) {
      if (store.getters.subscription === 'WRE') {
        if (to.path !== '/enterprise/dashboard') {
          return next('/enterprise/dashboard');
        }
      }
    } else if (to.path !== '/enterprise/login') {
      return next('/enterprise/login');
    }

    return next();
  }

  if (store.getters.isAuthenticated) {
    if (store.getters.subscription === 'WRE') {
      if (to.path !== '/enterprise/dashboard') {
        return next('/enterprise/dashboard');
      }
    } else if (to.path !== '/dashboard') {
      return next('/dashboard');
    }
  } else if (to.path !== '/login' && to.path !== '/enterprise/login') {
    if (to.path.startsWith('/enterprise')) {
      return next('/enterprise/login');
    }
    return next('/login');
  }

  return next();
});

export default router;
